import React from 'react';
import './Solutions.css';

const Solutions = () => {
  const solutions = [
    'Municipal & Utility Systems',
    'Enterprise Management Systems',
    'Revenue & Billing Platforms',
    'Data Dashboards & Reporting'
  ];

  return (
    <section id="solutions" className="solutions">
      <div className="container">
        <h2 className="section-title">Our Solutions</h2>
        <p className="section-subtitle">
          Specialized platforms designed for efficiency and scalability
        </p>
        <div className="solutions-grid">
          {solutions.map((solution, index) => (
            <div key={index} className="solution-card">
              <h3 className="solution-title">{solution}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solutions;

